// src/components/home/RoutesSection.jsx
import React from "react";
import MapSection from "../map/MapSection";

const RoutesSection = () => (
  <section id="routes-section" className="py-16">
    <MapSection />
  </section>
);

export default RoutesSection;
